<template>
<ul class="clubs settings">
  <li>
      <message-component v-if="showMessage" :status="status" :message="message"></message-component>
      <form>
          <ul>
            <li v-for="preference in preferences">
              <input
                      type="radio"
                      name="landing_page_preference"
                      :value="preference.value"
                      :id="preference.id"
                      :checked="preference.checked"
                      @click="setLandingPage(preference.value)"
                  >
                  <label :for="preference.id">
                      <img src="../../images/icons/modal-goals.svg">{{ preference.name }}
                  </label>
            </li>
          </ul>
      </form>
  </li>
</ul>
</template>
<script>
    import axios from 'axios'

    import MessageComponent from './MessageComponent.vue'

    export default {

        components: { MessageComponent },

        props: [
          'landing_page_preference',
          'endpoint',
          'setting_translations',
        ],

        data() {
            return {
                preferences : {
                  default : {
                    checked: false,
                    id: 'landingPageDefault',
                    value: 'default',
                    name: this.setting_translations['landing-page-preferences']['default']
                  },
                  myteam : {
                    checked: false,
                    id: 'landingPageMyTeam',
                    value: 'myteam',
                    name: this.setting_translations['landing-page-preferences']['my_team']
                  }
                },
                message : '',
                showMessage : false,
                status : 'generic'
            }
        },

        methods: {
          setLandingPage: function(value){
            this.setRadioStatus(value);
            axios.post(this.endpoint, {
              landing_page_preference : value
            }).then((response) => {
              this.message = this.setting_translations['api']['messages']['updated-landing-page'];
              this.status = 'success';
              this.showMessage = true;
                }).catch((response) => {
                  this.message = this.setting_translations['api']['messages']['invalid-request'];
                  this.status = 'error';
                  this.showMessage = true;
                });
          },

          setRadioStatus: function(landingPage){
            if (landingPage === 'default') {
              this.preferences.default.checked = true;
              this.preferences.myteam.checked = false;
            } else {
              this.preferences.myteam.checked = true;
              this.preferences.default.checked = false;
            }
          }
        },

        mounted() {
          this.setRadioStatus(this.landing_page_preference);
        }
    }
</script>